import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { Briefing } from "../../pages/Enterprise/modules/Briefing/types";

const getBriefing = async (
  id: string,
  mainAccountId?: string
): Promise<Briefing> => {
  try {
    const response = await axiosInstance.get<Briefing>(`/briefing/${id}`, {
      params: {
        mainAccountId,
      },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar o Briefing.",
    });

    throw new Error(`${error}`);
  }
};

const deleteBriefing = async (
  id: string,
  mainAccountId?: string
): Promise<Briefing> => {
  try {
    const response = await axiosInstance.delete<Briefing>(`/briefing/${id}`, {
      params: {
        mainAccountId,
      },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível deletar o Briefing.",
    });

    throw new Error(`${error}`);
  }
};

const createBriefing = async (
  id: string,
  data: Briefing,
  mainAccountId?: string
): Promise<Briefing> => {
  try {
    const queryParams = mainAccountId ? `?mainAccountId=${mainAccountId}` : "";
    const response = await axiosInstance.post<Briefing>(
      `/briefing/${id}${queryParams}`,
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar o Briefing.",
    });

    throw new Error(`${error}`);
  }
};

export const briefingService = {
  getBriefing,
  createBriefing,
  deleteBriefing,
};
